import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogContent,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Card,
  CardContent,
  Button,
  Slide,
  Grid,
  Tabs,
  Tab,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import TelegramIcon from '@mui/icons-material/Telegram';
import StarIcon from '@mui/icons-material/Star';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import { styled } from '@mui/material/styles';
import { useUser } from '../../contexts/userContext.jsx';
import { motion } from 'framer-motion';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="right" ref={ref} {...props} />;
});

const StyledCard = styled(Card)(({ theme }) => ({
  borderRadius: 20,
  boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
  cursor: 'pointer',
  border: '1px solid rgba(0,0,0,0.08)',
  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
  '&:hover': {
    transform: 'translateY(-5px) scale(1.03)',
    boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
  },
}));

const getMembershipStatus = (timesend) => {
  if (!timesend || timesend === 0) return 'free';
  const expireTime = timesend * 1000;
  const now = Date.now();
  const twentyYears = 10 * 365 * 24 * 60 * 60 * 1000;
  return expireTime - now > twentyYears ? 'permanent' : 'normal';
};

const TelegramGroup = ({ open, onClose }) => {
  const { userData } = useUser();
  const [status, setStatus] = useState('free');
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    if (userData?.timesend !== undefined) {
      const s = getMembershipStatus(userData.timesend);
      setStatus(s);
    }
  }, [userData]);

  const isTelegramWebApp = !!window.Telegram?.WebApp?.initData;

  const handleJoin = (link, access) => {
    if (!access) return;
    if (isTelegramWebApp) {
      window.Telegram.WebApp.openTelegramLink(link);
    } else {
      window.open(link, '_blank');
    }
  };

  const groups = [
    { title: '资源交流', subtitle: '普通VIP可进入。和其他用户交换资源，并获取最新资讯，以及参加活动赚取银币换VIP', link: 'https://t.me/+4E9v5iGBdps5OGM1', required: 'normal' },
    { title: '夫妻交流', subtitle: '永久会员才可加入。和真实夫妻互动，参加夫妻们组织的线下活动', link: 'https://t.me/+pJVnn8PGLds3YWMx', required: 'permanent' },
  ];

  const channels = [
    { title: 'SM捆绑', subtitle: 'SM捆绑调教类的频道', link: 'https://t.me/yzts520', required: 'free' },
    { title: '国产自拍', subtitle: '每天更新多部免费的国产视频', link: 'https://t.me/ywyvideochinese', required: 'free' },
    { title: '日本AV', subtitle: '每天更新多部免费的日本AV', link: 'https://t.me/ywyvideoav', required: 'free' },
    { title: '探花', subtitle: '每天更新多部免费的探花视频', link: 'https://t.me/ywywhores1', required: 'free' },
    { title: '国产AV', subtitle: '每天更新多部免费的国产AV', link: 'https://t.me/ywyntr', required: 'free' },
    { title: '电影', subtitle: '每天更新多部免费的电影', link: 'https://t.me/ywymvs', required: 'free' },
  ];

  const tools = [
    { title: '简体中文包', subtitle: '电报简体中文包', link: 'https://t.me/setlanguage/zh-hans-beta', required: 'free' },
    { title: '繁体中文包', subtitle: '电报繁体中文包', link: 'https://t.me/setlanguage/zh-hant-beta', required: 'free' },
    { title: '夜央地址器', subtitle: '电报夜未央地址发布器', link: 'https://t.me/ywydizhibot?start=1', required: 'free' },
  ];

  const hasAccess = (required) => {
    if (required === 'free') return true;
    if (required === 'normal') return status === 'normal' || status === 'permanent';
    if (required === 'permanent') return status === 'permanent';
    return false;
  };

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const tabData = [groups, channels, tools];

  // 增加更多暖色渐变
  const tabGradients = [
    [
      'linear-gradient(135deg, #42a5f5, #5c6bc0)',   // 蓝紫
      'linear-gradient(135deg, #7e57c2, #9575cd)',   // 紫色
      'linear-gradient(135deg, #26c6da, #26a69a)',   // 青绿
      'linear-gradient(135deg, #66bb6a, #43a047)',   // 绿色
    ],
    [
      'linear-gradient(135deg, #ff9e80, #ff6e54)', // 柔和珊瑚色
      'linear-gradient(135deg, #ff7043, #ff8a65)',   // 柔和橙
      'linear-gradient(135deg, #ec407a, #f06292)',   // 柔和粉
      'linear-gradient(135deg, #ab47bc, #ba68c8)',   // 柔和紫
    ],
    [
      'linear-gradient(135deg, #26a69a, #4db6ac)',   // 青绿
      'linear-gradient(135deg, #29b6f6, #4fc3f7)',   // 浅蓝
      'linear-gradient(135deg, #ffa726, #ffb74d)',   // 柔和橙
      'linear-gradient(135deg, #ef5350, #e57373)',   // 柔和红
    ],
  ];
  


  return (
    <Dialog
      fullScreen
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
      PaperProps={{
        sx: {
          background: '#ffffff',
          borderRadius: 2,
          boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
        }
      }}
    >
      <AppBar
        sx={{
          position: 'sticky',
          top: 0,
          zIndex: 1300,
          background: '#fff',
          color: '#000',
          boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
          borderBottom: '1px solid rgba(0,0,0,0.08)',
        }}
      >
        <Toolbar>
          <motion.div
            initial={{ x: '100%', opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.5, ease: 'easeOut' }}
            style={{ display: 'flex', alignItems: 'center', gap: 10, flexGrow: 1 }}
          >
            <IconButton edge="start" color="inherit" onClick={onClose}>
              <CloseIcon />
            </IconButton>
            <Typography variant="subtitle1" sx={{ fontWeight: 600, fontSize: 17 }}>
              夜未央电报群组
            </Typography>
          </motion.div>
        </Toolbar>

        <Tabs
          value={tabIndex}
          onChange={handleTabChange}
          textColor="inherit"
          indicatorColor="primary"
          sx={{
            px: 2,
            background: 'transparent',
            minHeight: '48px',
            '& .MuiTabs-indicator': {
              height: 3,
              borderRadius: 2,
              backgroundColor: '#ff7043', // 选中下划线暖色
            },
            '& .Mui-selected': {
              color: '#ff5722', // 选中字体颜色
              fontWeight: 600,
            },
          }}
        >
          <Tab label="群组" />
          <Tab label="免费频道" />
          <Tab label="电报工具" />
        </Tabs>
      </AppBar>

      <DialogContent
        sx={{
          pt: 3,
          background: '#f9f9f9',
          minHeight: '100vh',
          overflowY: 'auto',
        }}
      >
        <Grid container spacing={3}>
          {tabData[tabIndex].map((item, index) => {
            const access = hasAccess(item.required);
            let noteIcon = null;
            let noteText = '';

            switch (item.required) {
              case 'free':
                noteIcon = <StarIcon sx={{ fontSize: 16, color: '#4caf50', mr: 0.5 }} />;
                noteText = '免费';
                break;
              case 'normal':
                noteIcon = <MonetizationOnIcon sx={{ fontSize: 16, color: '#ff9800', mr: 0.5 }} />;
                noteText = '普通会员可加入';
                break;
              case 'permanent':
                noteIcon = <WorkspacePremiumIcon sx={{ fontSize: 16, color: '#f44336', mr: 0.5 }} />;
                noteText = '仅限永久会员';
                break;
              default:
                noteIcon = null;
                noteText = '';
            }

            const isGroupsTab = tabIndex === 0;
            const gradient = tabGradients[tabIndex][index % tabGradients[tabIndex].length];

            return (
              <Grid item xs={6} sm={6} key={index}>
                <StyledCard
                  component={motion.div}
                  whileHover={{ scale: 1.03 }}
                  sx={{
                    background: gradient,
                    color: '#fff',
                  }}
                  onClick={() => {
                    if (!isGroupsTab && access) handleJoin(item.link, access);
                  }}
                >
                  <CardContent>
                    <Typography
                      variant="subtitle1"
                      gutterBottom
                      sx={{ fontWeight: 600, fontSize: 16, lineHeight: 1.4, letterSpacing: 0.5 }}
                    >
                      {item.title}
                    </Typography>
                    <Typography variant="body2" sx={{ opacity: 0.85, mb: 1.2, fontSize: 14, lineHeight: 1.5 }}>
                      {item.subtitle}
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        fontStyle: 'italic',
                        opacity: 0.8,
                        mb: 1,
                        letterSpacing: 0.5,
                        lineHeight: 1.4,
                      }}
                    >
                      {noteIcon}
                      {noteText}
                    </Typography>

                    {isGroupsTab && (
                      <Button
                        fullWidth
                        variant="contained"
                        startIcon={<TelegramIcon />}
                        onClick={() => handleJoin(item.link, access)}
                        disabled={!access}
                        sx={{
                          background: access ? gradient : '#cccccc',
                          color: '#fff',
                          borderRadius: 3,
                          textTransform: 'none',
                          fontWeight: 600,
                          fontSize: '13px',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          '&:hover': {
                            background: access ? gradient : '#bbbbbb',
                          },
                        }}
                      >
                        {access
                          ? '进入群组'
                          : item.required === 'permanent'
                          ? '永久会员进'
                          : '会员加入'}
                      </Button>
                    )}
                  </CardContent>
                </StyledCard>
              </Grid>
            );
          })}
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default TelegramGroup;
